define('ANSI/Components/Content/ButtonWithModal',['jquery'], function ($) {

    function ButtonWithModal(scope, showExitButton, uniqueId) {
        $('.score-button.js-show-modal', scope).on("click", function (e) {
            e.preventDefault();
            $('#' + uniqueId + '-modal').modal("show");
        });

        if (showExitButton) {
            $('.score-button.js-hide-modal', scope).on("click", function (e) {
                e.preventDefault();
                $('#' + uniqueId + '-modal').modal("hide");
            });
        }
        
    }

    ButtonWithModal.init = function init(args) {
        return args.IsEditorEditing === true ? null : new ButtonWithModal(args.scope, args.ShowExitButton, args.UniqueId);
    };

    return ButtonWithModal;

});
